import { render, staticRenderFns } from "./ALink.vue?vue&type=template&id=eb1bdff4"
import script from "./ALink.vue?vue&type=script&lang=js"
export * from "./ALink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports